// The client is always served by the same origin that answers /api and
// /socket.io: nginx proxies both in production, and the Vite dev server
// proxies both in development. So the base is always relative.
//
// Baking an absolute URL in at build time (the old REACT_APP_OUTLAW_API_URL)
// meant the bundle only worked on the one domain it was built for.
export const baseUrl = "";

export const socketUrl = (code) => `/${code}`;
